import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    sectionContainer: {
        display: "flex",
        gridGap: 12,
        gridTemplateColumns: "repeat(3, 1fr)",
    },
    titleContainer: {
        padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
        borderBottom: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        width: "100%",
    },
    title: {
        color: theme.palette.info.main,
    },
    infoContainer: {
        padding: `0 ${theme.spacing(6)}`,
    },
    seeMoreButton: {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent",
        width: "100%",
        borderWidth: 0,
        padding: `${theme.spacing(3)} 0`,
        fontFamily: "inherit",
        fontSize: "inherit",
        fontStyle: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        cursor: "pointer",
    },
    icon: {
        color: theme.palette.primary.dark,
    },
    gridContainer: {
        padding: "0px 22px 22px 22px",
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gridTemplateRows: "1fr 1fr 1fr",
        gap: "12px 12px",
        gridTemplateAreas: `
      "UptimeDowntimeBartList OverallDowntimeSummary MachineCenters"
      "WeekTrend WeekTrend FunctionalLocations"
      "FailureCodesByType FailureCodesByType FailureCodesByType"`,
    },
    UptimeDowntimeBartList: { gridArea: "UptimeDowntimeBartList" },
    OverallDowntimeSummary: { gridArea: "OverallDowntimeSummary" },
    MachineCenters: { gridArea: "MachineCenters" },
    WeekTrend: { gridArea: "WeekTrend" },
    FunctionalLocations: { gridArea: "FunctionalLocations" },
    FailureCodesByType: { gridArea: "FailureCodesByType" },
}));
